import React, { createContext, useState } from 'react';

// Create the context
export const BurgerMenuContext = createContext();

// Create a provider component
export const BurgerMenuProvider = ({ children }) => {
 

    const [comp, setComp] = useState(null);

    const [showSideBar, setShowSideBar] = useState(false);

    


    const updateComp = (e)=>{
        setComp(e)
    }

  return (
    <BurgerMenuContext.Provider value={{ ...comp, updateComp, showSideBar, setShowSideBar }}>
      {children}
    </BurgerMenuContext.Provider>
  );
};
